export default __webpack_public_path__ + "static/media/image5.487d6ffa.png";